export const chartStatuses = {
  active: 'Active',
  productive: 'Productive',
  events: 'Events',
  utilization: 'Utilization',
  timeline: 'Timeline',
  paid: 'Paid',
};
